/**
 * @generated SignedSource<<d14b4ed0bb9ffd34d3c2120c1cd18b5e>>
 * @relayHash e74ec53d0428f0c17b42c6c6d33179b5
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/567.0.0-2026-07-09T16:56:40.509Z/sellerApplicationRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sellerApplicationRootQuery$variables = {
  leadId: string;
};
export type sellerApplicationRootQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationWrapper_viewer">;
  };
};
export type sellerApplicationRootQuery = {
  response: sellerApplicationRootQuery$data;
  variables: sellerApplicationRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "leadId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "abbreviation",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sellerApplicationRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SellerApplicationWrapper_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "sellerApplicationRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "newSellerPricing",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "newSellerPricing"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"newSellerPricing\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "country",
                "value": ""
              }
            ],
            "kind": "ScalarField",
            "name": "isCountryInEu",
            "storageKey": "isCountryInEu(country:\"\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "contextName",
                "value": "SELLER_APPLICATION"
              }
            ],
            "concreteType": "GeographySalesforce",
            "kind": "LinkedField",
            "name": "geographySalesforce",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "countryCode",
                    "value": "US"
                  }
                ],
                "concreteType": "states",
                "kind": "LinkedField",
                "name": "states",
                "plural": true,
                "selections": (v1/*:: as any*/),
                "storageKey": "states(countryCode:\"US\")"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "countries",
                "kind": "LinkedField",
                "name": "countries",
                "plural": true,
                "selections": (v1/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": "geographySalesforce(contextName:\"SELLER_APPLICATION\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "leadId",
                "variableName": "leadId"
              }
            ],
            "concreteType": "SellerLeadSalesforceType",
            "kind": "LinkedField",
            "name": "salesforceSellerLead",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyISOCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recordId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "company",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "country",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "street",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryBusinessFocus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eori",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasExperienceSellingOnline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "businessType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "galleryRepresentation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "whereRepresented",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "specialty",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimatedInventorySize",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "averageItemPrice",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numSoldLastYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimatedMonthlyUploads",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSellerOnOtherMarketPlace",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "otherMarketPlaceDetails",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hoursManagePerWeek",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "instagram",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "facebook",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "website",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nmiReason",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "readFromSF",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "sellerLeadReadFromSF"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"sellerLeadReadFromSF\")"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/567.0.0-2026-07-09T16:56:40.509Z/sellerApplicationRootQuery",
    "metadata": {},
    "name": "sellerApplicationRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d687071839319fb4fef287a55054c0b2";

export default node;
